import { container } from '../../../DataDomain';
import { IApiPathManager } from '../../../infrastructures/config/ApiPathManager';
import { DI } from '@intigral/constant/config/DIContainer';
import { API_IDS } from '@intigral/constant';
import ResponseError from '../../entities/errors/ResponseError';
import { IGetCatchUpListParams, IGetCatchUpListResponse } from '../../../entity/interface/iCmsCarousel';
import { ICMSCarouselRepository } from '../../repositories/interfaces/ICMSCarouselRepository';

export interface IGetCatchUpCarouselUseCase {
    execute(
        dataSource: string,
        apiKey: string,
        params?: IGetCatchUpListParams,
        isMixedCatchup?: boolean
    ): Promise<IGetCatchUpListResponse['data']>;
}

export class GetCatchUpCarouselUseCase implements IGetCatchUpCarouselUseCase {
    // Lazy getters for dependencies to avoid circular dependencies
    private get cmsCarouselRepo(): ICMSCarouselRepository {
        return container.resolve<ICMSCarouselRepository>(DI.REPOSITORIES.ICMSCarouselRepository);
    }
    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        dataSource: string,
        apiKey: string,
        params?: IGetCatchUpListParams,
        isMixedCatchup?: boolean
    ): Promise<IGetCatchUpListResponse['data']> {
        const response = await this.cmsCarouselRepo.getCatchUpCarousel(dataSource, apiKey, params, isMixedCatchup);
        if (typeof response.data !== 'undefined') {
            return response.data;
        }
        if (typeof response.error !== 'undefined') {
            const url = this.apiPathManager.replacePlaceholders(dataSource);
            throw new ResponseError(
                { url: url },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return response.data;
    }
}
